export const messageRoutes = {
  allMessages: () => '/messages',
  unfinalizeMessage: () => '/messages/unfinalize',
  finalizeMessage: () => '/messages/finalize',
  countUnfinalizedMessages: () => '/messages/unfinalized',
  uploadMessageFile: () => '/messages/files',
  getMessageFileSettings: () => '/messages/files/settings',
  getMessageFileById: (fileId: string) => `/messages/files/${fileId}`,
};
